import { isLeftSideDrawerOpen } from '@/store/modules/leftSideDrawer/getters';
import { useStore } from '@/utils/store';

export const useLeftSideDrawerGetters = () => {
	const { getter } = useStore();
	return {
		isLeftSideDrawerOpen: getter<boolean>(isLeftSideDrawerOpen),
	};
};
